import React from "react"

const STATUS_STYLES = {
  active: "bg-green-100 text-green-700",
  pending: "bg-blue-100 text-blue-700",
  paused: "bg-amber-100 text-amber-700",
  expired: "bg-red-100 text-red-700",
  completed: "bg-slate-200 text-slate-700",
  deleted: "bg-slate-200 text-slate-500",
}

export const StatusBadge = ({ status }) => {
  const s = String(status || "unknown").toLowerCase()
  const cls = STATUS_STYLES[s] || "bg-slate-100 text-slate-600"
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium capitalize ${cls}`}>
      {s}
    </span>
  )
}

export const formatDate = (d) => {
  if (!d) return "--"
  const date = new Date(d)
  if (isNaN(date.getTime())) return "--"
  return date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })
}

export const Owner = ({ owner }) => {
  if (!owner || (!owner.email && !owner.name)) return <span className="text-admin_text_secondary">—</span>
  return (
    <div className="flex flex-col leading-tight">
      <span>{owner.name || owner.email}</span>
      {owner.name && owner.email ? (
        <span className="text-xs text-admin_text_secondary">{owner.email}</span>
      ) : null}
    </div>
  )
}
